var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tela-component',{attrs:{"title":"Formação de Carga"}},[(_vm.carregando)?_c('carregando-overlay',{attrs:{"title":"Aguarde...","subtitle":"Buscando dados da carga"}}):[_c('informar-placa-veiculo-form-carga'),(_vm.veiculo.dados)?_c('distribuir-caixas-form-carga',{staticClass:"mt-2"}):_vm._e()],_c('router-view')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }